import { RemoveCircle, AddCircle } from 'emotion-icons/material';
import React__default, { useRef } from 'react';
import { ACCORDION } from '../../utils/dataTrackingValues.js';
import Typography from '../Typography/index.js';
import { ItemHeader, ItemContent } from './Accordion.styles.js';

var AccordionItem = function AccordionItem(_ref) {
  var _ref$item = _ref.item,
    item = _ref$item === void 0 ? {
      title: '',
      content: ''
    } : _ref$item,
    index = _ref.index,
    isOpen = _ref.isOpen,
    handleOpen = _ref.handleOpen,
    requestId = _ref.requestId;
  var title = item.title,
    content = item.content;
  var ItemsWrapperRef = useRef();
  var ArrowNavigation = function ArrowNavigation(event) {
    var _ItemsWrapperRef$curr;
    var keyCode = event.keyCode;
    var direction;
    switch (keyCode) {
      // ArrowUp
      case 38:
        direction = 'previousSibling';
        break;

      // ArrowDown
      case 40:
        direction = 'nextSibling';
        break;

      // Space Character
      case 32:
        // Prevents the page from scrolling when they hit the spacebar to open the accordion item
        event.preventDefault();
        break;
      default:
        direction = null;
    }
    var elementToFocus = ItemsWrapperRef === null || ItemsWrapperRef === void 0 || (_ItemsWrapperRef$curr = ItemsWrapperRef.current) === null || _ItemsWrapperRef$curr === void 0 || (_ItemsWrapperRef$curr = _ItemsWrapperRef$curr[direction]) === null || _ItemsWrapperRef$curr === void 0 ? void 0 : _ItemsWrapperRef$curr.firstChild;
    if (typeof elementToFocus !== 'undefined' && elementToFocus !== null) {
      elementToFocus.focus();
    }
  };
  var handleClick = function handleClick(event, question) {
    if (event.type === 'click' || event.type === 'keydown' && (event.key === 'Enter' || event.keyCode === 32)) {
      handleOpen(index);
    }

    // Allows users to navigate through the items with up/down arrows
    ArrowNavigation(event);
    ACCORDION.handleClick(question, requestId);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ItemsWrapperRef,
    "data-testid": "accordion-item".concat(index),
    className: "leshen-accordion-item"
  }, /*#__PURE__*/React__default.createElement(ItemHeader, {
    className: "item-header",
    role: "button",
    tabIndex: "0",
    onClick: function onClick(event) {
      return handleClick(event, title);
    },
    onKeyDown: function onKeyDown(event) {
      return handleClick(event, title);
    }
  }, isOpen ? /*#__PURE__*/React__default.createElement(RemoveCircle, {
    className: "remove"
  }) : /*#__PURE__*/React__default.createElement(AddCircle, {
    className: "add"
  }), /*#__PURE__*/React__default.createElement(Typography, {
    className: "header-text",
    variant: "feature"
  }, title)), /*#__PURE__*/React__default.createElement(ItemContent, {
    className: "item-content",
    isOpen: isOpen,
    "data-testid": "accordion-content".concat(index)
  }, content));
};
var AccordionItem$1 = AccordionItem;

export { AccordionItem$1 as default };
//# sourceMappingURL=AccordionItem.js.map
